import React, { createContext, useState } from 'react'
import { useDidUpdateEffect } from '@mc/design-system'
import { useStaticData } from './useStaticData'

const initialValue: Record<string, unknown> = {}
const StaticDataContext = createContext(initialValue)
export default StaticDataContext

type ProviderProps = {
  children?: React.ReactNode
  providerKey?: string
  value: Record<string, unknown>
}

export const StaticDataProvider = ({
  value,
  providerKey,
  children,
}: ProviderProps) => {
  const parentData = useStaticData() ?? {}
  const [staticData, setStaticData] = useState({ ...parentData, ...value })

  useDidUpdateEffect(
    () =>
      setStaticData({
        ...parentData,
        ...value,
      }),
    [providerKey, parentData],
  )

  // The `key` prop forces React to re-render the context provider when the key changes
  // This aims to avoid bugs where child components are not updated with new data
  // (this is a frequent issue with NextJS soft navigations)
  return (
    <StaticDataContext.Provider value={staticData}>
      {children}
    </StaticDataContext.Provider>
  )
}
